import ContentBuilder from "../core/ContentBuilder";
import { Page } from "../core/Page";
import styles from './ContentPage.module.scss';
import { mergeClassNames } from '../utils/mergeClassNames';


export class ContentPage extends Page
{

	protected static _styles = styles;

	private _blockContent(tag, props, content)
	{
		return (
			<div {...props} className={mergeClassNames([props['className'], 'block-container'], styles)}>
				<div className={mergeClassNames(['block-content'], styles)}>
					{content}
				</div>
			</div>
		);
	}

	render()
	{
		return(
			<>
				{
					ContentBuilder.build(this.props.data.content, {BlockContent: this._blockContent}, ContentPage.styles)
				}
			</>
		);
	}
}